/**
 * @generated SignedSource<<21cc0c8ee9c64177534d9cce790539be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
export type LearningAchievementsTable_Query$variables = {
  isCertified?: boolean | null;
};
export type LearningAchievementsTable_Query$data = {
  readonly LearnV2: {
    readonly LearningAchievements: ReadonlyArray<{
      readonly areCmePointsExported: boolean;
      readonly categoryOpt: string | null;
      readonly finishedAt: any;
      readonly formatTypes: ReadonlyArray<ElementTypeV2>;
      readonly issuedCertificateOpt: {
        readonly fileRef: {
          readonly url: string | null;
        } | null;
      } | null;
      readonly learnOpportunity: {
        readonly id: string;
      } | null;
      readonly points: number;
      readonly title: string;
    }>;
  };
};
export type LearningAchievementsTable_Query = {
  response: LearningAchievementsTable_Query$data;
  variables: LearningAchievementsTable_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isCertified"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "isCertified",
    "variableName": "isCertified"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "LearnOpportunityV2",
  "kind": "LinkedField",
  "name": "learnOpportunity",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryOpt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatTypes",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areCmePointsExported",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LearningAchievementsTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Queries",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LearningAchievement",
            "kind": "LinkedField",
            "name": "LearningAchievements",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssuedCertificateV2",
                "kind": "LinkedField",
                "name": "issuedCertificateOpt",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "fileRef",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LearningAchievementsTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnV2Queries",
        "kind": "LinkedField",
        "name": "LearnV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LearningAchievement",
            "kind": "LinkedField",
            "name": "LearningAchievements",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssuedCertificateV2",
                "kind": "LinkedField",
                "name": "issuedCertificateOpt",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "fileRef",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14b292800d93673f9e4fbe3e62ba52ff",
    "id": null,
    "metadata": {},
    "name": "LearningAchievementsTable_Query",
    "operationKind": "query",
    "text": "query LearningAchievementsTable_Query(\n  $isCertified: Boolean\n) {\n  LearnV2 {\n    LearningAchievements(isCertified: $isCertified) {\n      learnOpportunity {\n        id\n      }\n      finishedAt\n      title\n      categoryOpt\n      formatTypes\n      areCmePointsExported\n      points\n      issuedCertificateOpt {\n        fileRef {\n          url\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6cee3d9d5948f1a2dd093788fb74953";

export default node;
